<template>
  <div>
    <h1>Results</h1>
    <b-list-group>
      <b-list-group-item>
        <b-button variant="danger" @click="resetFields" block>
          Clear Results
        </b-button>
      </b-list-group-item>
      <b-list-group-item v-if="trips.length === 0">
        <!--        <h1 class="font-weight-bold text-center text-secondary p-3">-->
        <!--          No Results Found-->
        <!--        </h1>-->
      </b-list-group-item>
      <b-list-group-item
        v-if="trips.length !== 0 && suburb_notes"
        class="notes"
      >
        <h1>SUBURB NOTES:</h1>
        <p class="mt-2">{{ suburb_notes }}</p>
      </b-list-group-item>
      <b-list-group-item
        class="p-0 border-0"
        v-for="trip in trips"
        :key="trip.id"
      >
        <b-list-group class="rounded-0">
          <b-list-group-item class="p-0">
            <b-button
              block
              v-b-toggle="trip.id.toString()"
              variant="light"
              class="border-0 p-3 bg-light d-flex justify-content-between"
            >
              <span>
                <span class="mr-2">{{ trip.the_time }}</span>
                <span>{{ trip.destination }}</span>
              </span>
              <span>
                <b-icon icon="chevron-right" variant="dark"></b-icon>
              </span>
            </b-button>
          </b-list-group-item>
          <b-collapse
            :id="trip.id.toString()"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-list-group-item class="notes">
              <span class="p-1">
                <p v-if="trip.the_time" class="my-0">
                  <span class="font-weight-bold">Pickup Time:</span>
                  <span class="ml-2">{{ trip.the_time }}</span>
                </p>
                <p v-if="trip.destination" class="my-0">
                  <span class="font-weight-bold">Destination:</span>
                  <span class="ml-2">{{ trip.desto }}</span>
                </p>
              </span>
              <span class="p-1">
                <p v-if="trip.notes" class="my-0">
                  <span class="font-weight-bold">Trip Notes:</span>
                  <span class="ml-2">{{ trip.notes }}</span>
                </p>
                <p
                  v-if="trip_school_notes(trip.schools) && school"
                  class="my-0"
                >
                  <span class="font-weight-bold">School Notes:</span>
                  <span class="ml-2">
                    {{ trip_school_notes(trip.schools) }}
                  </span>
                </p>
                <p v-if="trip_suburb_notes(trip.areas) && suburb" class="my-0">
                  <span class="font-weight-bold">Suburb Notes:</span>
                  <span class="ml-2">{{ trip_suburb_notes(trip.areas) }}</span>
                </p>
              </span>
              <div class="row p-1 justify-content-end">
                <div class="col"></div>
                <div class="col text-right">
                  <a
                    :href="downloadLink(trip)"
                    class="btn btn-danger downloadbtn pull-right"
                    style="color: white"
                    target="pdf_download"
                    >Download PDF Timetable/Map</a
                  >
                </div>
              </div>
            </b-list-group-item>
          </b-collapse>
        </b-list-group>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "SearchResult",
  props: {
    trips: {
      type: Array,
    },
    suburb_notes: {
      type: String,
      default: "",
    },
    suburb: {
      type: Number,
      required: false,
    },
    school: {
      type: Number,
      required: false,
    },
  },
  methods: {
    ...mapActions(["resetSearch"]),
    resetFields() {
      this.resetSearch();
      this.$emit("resetFields");
    },
    downloadLink(trip) {
      return (
        "http://mcharrys.s3-website-ap-northeast-1.amazonaws.com/" +
        trip.run_number +
        ".pdf"
      );
    },
  },
  computed: {
    trip_school_notes() {
      return (schools) =>
        this.school ? _.find(schools, ["school", this.school]).notes : "";
    },
    trip_suburb_notes() {
      return (suburbs) =>
        this.suburb ? _.find(suburbs, ["area", this.suburb]).notes : "";
    },
  },
};
</script>

<style scoped>
a.downloadbtn {
  color: white;
}
</style>
